export default "__VITE_ASSET__4b754c35__"